// ------------------------------
// uiLogic/buttons.ts
// Centralised sizing + styling for top-nav buttons
// ------------------------------

/*  Mantine variant used for every ActionIcon  */
export const TOP_BUTTON_VARIANT = "light";

/*  “xl” keeps Mantine’s internal padding generous.
    Actual outer dimensions are controlled by our custom style object.  */
export const TOP_BUTTON_SIZE = "xl";

export const TOP_BUTTON_RADIUS = "lg";

/**
 * Break-points chosen to cover common real-world devices
 * ≤320 px  : legacy 3.5–4" screens (e.g. iPhone 4, JioPhone 2)--wrap allowed
 * ≤414 px  : iPhone 11/12/13/14/15 (non-Max)                  --shrink
 * ≤768 px  : large phones & small tablets                     --mobile size
 * >768 px  : desktop size
 */
const getButtonMetrics = () => {
  const w =
    typeof window !== "undefined" && window.innerWidth
      ? window.innerWidth
      : 1024; // fallback for SSR

  if (w <= 280) return { size: 38, icon: 18, gap: 6 }; // tiny for very small screens
  if (w <= 320) return { size: 40, icon: 19, gap: 8 }; // very small
  if (w <= 360) return { size: 42, icon: 20, gap: 8 }; // small (your Galaxy S8+ case)
  if (w <= 414) return { size: 44, icon: 21, gap: 10 }; // iPhone standard
  if (w <= 480) return { size: 46, icon: 22, gap: 12 }; // larger phones
  if (w <= 768) return { size: 50, icon: 24, gap: 16 }; // tablets
  return { size: 60, icon: 28, gap: 20 }; // desktop
};

/*  Style object applied to every ActionIcon */
export const getTopButtonStyle = () => {
  const { size } = getButtonMetrics();

  return {
    width: size,
    height: size,
    fontSize: size * 0.45,
    boxShadow: "0 0 8px rgba(255,255,255,0.2)",
    border: "1px solid rgba(255,255,255,0.1)",
    backgroundColor: "rgba(255,255,255,0.08)",
    backdropFilter: "blur(4px)",
  } as const;
};

/*  Icon (Tabler) size string fed into <IconXYZ size={…} />  */
export const getTopIconSize = () => `${getButtonMetrics().icon}px`;

/*  Additional glow & border when a button is active  */
export const getActiveButtonStyle = () =>
  ({
    ...getTopButtonStyle(),
    boxShadow: "0 0 16px rgba(255,255,255,0.4),0 0 8px rgba(59,130,246,0.6)",
    border: "2px solid rgba(59,130,246,0.8)",
    backgroundColor: "rgba(59,130,246,0.15)",
    transform: "scale(1.05)",
  } as const);

/*  Gap fed into the Mantine <Group gap={…} /> wrapper */
export const getTopGap = () => getButtonMetrics().gap;
